/* tslint:disable */
/* eslint-disable */
/**
 * MAPIIO API
 * API mapové aplikace Mapiio pro klientskou JavaScriptovou / React část.
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { EnumOutputFormat } from '../model';
// @ts-ignore
import { Feature } from '../model';
// @ts-ignore
import { Polygon } from '../model';
// @ts-ignore
import { PrintBodyVO } from '../model';
// @ts-ignore
import { PrintConfigVO } from '../model';
// @ts-ignore
import { TopicPrintRequestVO } from '../model';
// @ts-ignore
import * as Objs from './index'
// @ts-ignore
import { DataResponseVO, DataRequestVO, ExportRequestVO } from '@mc/data-filter-react';

/**
 * PublicPrintControllerApi - axios parameter creator
 * @export
 */
export const PublicPrintControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} kodOrganizace Kód organizace pro načtení konfigurace tisku.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        publicGetPrintConfig: async (kodOrganizace: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'kodOrganizace' is not null or undefined
            assertParamExists('publicGetPrintConfig', 'kodOrganizace', kodOrganizace)
            const localVarPath = `/public/api/print/config`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (kodOrganizace !== undefined) {
                localVarQueryParameter['kodOrganizace'] = kodOrganizace;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} topic ID tématu pro tisk.
         * @param {string} kodOrganizace Kód organizace pro načtení topicu a vrstev.
         * @param {Array<Feature>} feature 
         * @param {EnumOutputFormat} [outputFormat] 
         * @param {number} [minScale] Volitelná specifikace úrovně minimálního přiblížení. Výchozí hodnota je 500.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        publicPrintFeatures: async (topic: string, kodOrganizace: string, feature: Array<Feature>, outputFormat?: EnumOutputFormat, minScale?: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'topic' is not null or undefined
            assertParamExists('publicPrintFeatures', 'topic', topic)
            // verify required parameter 'kodOrganizace' is not null or undefined
            assertParamExists('publicPrintFeatures', 'kodOrganizace', kodOrganizace)
            // verify required parameter 'feature' is not null or undefined
            assertParamExists('publicPrintFeatures', 'feature', feature)
            const localVarPath = `/public/api/print/features`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (topic !== undefined) {
                localVarQueryParameter['topic'] = topic;
            }

            if (kodOrganizace !== undefined) {
                localVarQueryParameter['kodOrganizace'] = kodOrganizace;
            }

            if (outputFormat !== undefined) {
                localVarQueryParameter['outputFormat'] = outputFormat;
            }

            if (minScale !== undefined) {
                localVarQueryParameter['minScale'] = minScale;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(feature, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Vytiskne mapu pro features v selectedLayers predaneho topicu ve veřejném režimu
         * @param {string} topic ID tématu pro tisk.
         * @param {string} kodOrganizace Kód organizace pro načtení topicu a vrstev.
         * @param {PrintBodyVO} printBodyVO 
         * @param {boolean} [forceBaseStyle] Příznak pro vynucení základního stylu.
         * @param {Array<number>} [backgroundLayerIds] ID pozadových vrstev.
         * @param {Array<number>} [layerIds] ID vektorových vrstev.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        publicPrintFeaturesForLayers: async (topic: string, kodOrganizace: string, printBodyVO: PrintBodyVO, forceBaseStyle?: boolean, backgroundLayerIds?: Array<number>, layerIds?: Array<number>, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'topic' is not null or undefined
            assertParamExists('publicPrintFeaturesForLayers', 'topic', topic)
            // verify required parameter 'kodOrganizace' is not null or undefined
            assertParamExists('publicPrintFeaturesForLayers', 'kodOrganizace', kodOrganizace)
            // verify required parameter 'printBodyVO' is not null or undefined
            assertParamExists('publicPrintFeaturesForLayers', 'printBodyVO', printBodyVO)
            const localVarPath = `/public/api/print/features-for-layers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (topic !== undefined) {
                localVarQueryParameter['topic'] = topic;
            }

            if (kodOrganizace !== undefined) {
                localVarQueryParameter['kodOrganizace'] = kodOrganizace;
            }

            if (forceBaseStyle !== undefined) {
                localVarQueryParameter['forceBaseStyle'] = forceBaseStyle;
            }

            if (backgroundLayerIds) {
                localVarQueryParameter['backgroundLayerIds'] = backgroundLayerIds;
            }

            if (layerIds) {
                localVarQueryParameter['layerIds'] = layerIds;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(printBodyVO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Vytiskne mapu pro features v selectedLayers predaneho topicu ve veřejném režimu
         * @param {string} topic ID tématu pro tisk.
         * @param {string} kodOrganizace Kód organizace pro načtení topicu a vrstev.
         * @param {TopicPrintRequestVO} topicPrintRequestVO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        publicPrintFeaturesForTopic: async (topic: string, kodOrganizace: string, topicPrintRequestVO: TopicPrintRequestVO, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'topic' is not null or undefined
            assertParamExists('publicPrintFeaturesForTopic', 'topic', topic)
            // verify required parameter 'kodOrganizace' is not null or undefined
            assertParamExists('publicPrintFeaturesForTopic', 'kodOrganizace', kodOrganizace)
            // verify required parameter 'topicPrintRequestVO' is not null or undefined
            assertParamExists('publicPrintFeaturesForTopic', 'topicPrintRequestVO', topicPrintRequestVO)
            const localVarPath = `/public/api/print/features-for-topic`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (topic !== undefined) {
                localVarQueryParameter['topic'] = topic;
            }

            if (kodOrganizace !== undefined) {
                localVarQueryParameter['kodOrganizace'] = kodOrganizace;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(topicPrintRequestVO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Vytiskne mapu rozdělenou na více stránek (klad listů) ve veřejném režimu.
         * @param {string} topic ID tématu pro tisk.
         * @param {string} kodOrganizace Kód organizace pro načtení topicu a vrstev.
         * @param {string} format velikost stránky (A4, A3, ...)
         * @param {number} vyska maximální výška čtverce
         * @param {number} sirka maximální šířka jednoho čtverce (v metrech jako JTSK)
         * @param {Polygon} polygon 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        publicPrintKladlistuForTopic: async (topic: string, kodOrganizace: string, format: string, vyska: number, sirka: number, polygon: Polygon, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'topic' is not null or undefined
            assertParamExists('publicPrintKladlistuForTopic', 'topic', topic)
            // verify required parameter 'kodOrganizace' is not null or undefined
            assertParamExists('publicPrintKladlistuForTopic', 'kodOrganizace', kodOrganizace)
            // verify required parameter 'format' is not null or undefined
            assertParamExists('publicPrintKladlistuForTopic', 'format', format)
            // verify required parameter 'vyska' is not null or undefined
            assertParamExists('publicPrintKladlistuForTopic', 'vyska', vyska)
            // verify required parameter 'sirka' is not null or undefined
            assertParamExists('publicPrintKladlistuForTopic', 'sirka', sirka)
            // verify required parameter 'polygon' is not null or undefined
            assertParamExists('publicPrintKladlistuForTopic', 'polygon', polygon)
            const localVarPath = `/public/api/print/klad-listu-for-topic`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (topic !== undefined) {
                localVarQueryParameter['topic'] = topic;
            }

            if (kodOrganizace !== undefined) {
                localVarQueryParameter['kodOrganizace'] = kodOrganizace;
            }

            if (format !== undefined) {
                localVarQueryParameter['format'] = format;
            }

            if (vyska !== undefined) {
                localVarQueryParameter['vyska'] = vyska;
            }

            if (sirka !== undefined) {
                localVarQueryParameter['sirka'] = sirka;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(polygon, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PublicPrintControllerApi - functional programming interface
 * @export
 */
export const PublicPrintControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PublicPrintControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} kodOrganizace Kód organizace pro načtení konfigurace tisku.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async publicGetPrintConfig(kodOrganizace: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PrintConfigVO>> {

            const localVarAxiosArgs = await localVarAxiosParamCreator.publicGetPrintConfig(kodOrganizace, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} topic ID tématu pro tisk.
         * @param {string} kodOrganizace Kód organizace pro načtení topicu a vrstev.
         * @param {Array<Feature>} feature 
         * @param {EnumOutputFormat} [outputFormat] 
         * @param {number} [minScale] Volitelná specifikace úrovně minimálního přiblížení. Výchozí hodnota je 500.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async publicPrintFeatures(topic: string, kodOrganizace: string, feature: Array<Feature>, outputFormat?: EnumOutputFormat, minScale?: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {

            const localVarAxiosArgs = await localVarAxiosParamCreator.publicPrintFeatures(topic, kodOrganizace, feature, outputFormat, minScale, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Vytiskne mapu pro features v selectedLayers predaneho topicu ve veřejném režimu
         * @param {string} topic ID tématu pro tisk.
         * @param {string} kodOrganizace Kód organizace pro načtení topicu a vrstev.
         * @param {PrintBodyVO} printBodyVO 
         * @param {boolean} [forceBaseStyle] Příznak pro vynucení základního stylu.
         * @param {Array<number>} [backgroundLayerIds] ID pozadových vrstev.
         * @param {Array<number>} [layerIds] ID vektorových vrstev.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async publicPrintFeaturesForLayers(topic: string, kodOrganizace: string, printBodyVO: PrintBodyVO, forceBaseStyle?: boolean, backgroundLayerIds?: Array<number>, layerIds?: Array<number>, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {

            const localVarAxiosArgs = await localVarAxiosParamCreator.publicPrintFeaturesForLayers(topic, kodOrganizace, printBodyVO, forceBaseStyle, backgroundLayerIds, layerIds, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Vytiskne mapu pro features v selectedLayers predaneho topicu ve veřejném režimu
         * @param {string} topic ID tématu pro tisk.
         * @param {string} kodOrganizace Kód organizace pro načtení topicu a vrstev.
         * @param {TopicPrintRequestVO} topicPrintRequestVO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async publicPrintFeaturesForTopic(topic: string, kodOrganizace: string, topicPrintRequestVO: TopicPrintRequestVO, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {

            const localVarAxiosArgs = await localVarAxiosParamCreator.publicPrintFeaturesForTopic(topic, kodOrganizace, topicPrintRequestVO, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Vytiskne mapu rozdělenou na více stránek (klad listů) ve veřejném režimu.
         * @param {string} topic ID tématu pro tisk.
         * @param {string} kodOrganizace Kód organizace pro načtení topicu a vrstev.
         * @param {string} format velikost stránky (A4, A3, ...)
         * @param {number} vyska maximální výška čtverce
         * @param {number} sirka maximální šířka jednoho čtverce (v metrech jako JTSK)
         * @param {Polygon} polygon 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async publicPrintKladlistuForTopic(topic: string, kodOrganizace: string, format: string, vyska: number, sirka: number, polygon: Polygon, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {

            const localVarAxiosArgs = await localVarAxiosParamCreator.publicPrintKladlistuForTopic(topic, kodOrganizace, format, vyska, sirka, polygon, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * PublicPrintControllerApi - factory interface
 * @export
 */
export const PublicPrintControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PublicPrintControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {string} kodOrganizace Kód organizace pro načtení konfigurace tisku.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        publicGetPrintConfig(kodOrganizace: string, options?: any): AxiosPromise<PrintConfigVO> {
            return localVarFp.publicGetPrintConfig(kodOrganizace, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} topic ID tématu pro tisk.
         * @param {string} kodOrganizace Kód organizace pro načtení topicu a vrstev.
         * @param {Array<Feature>} feature 
         * @param {EnumOutputFormat} [outputFormat] 
         * @param {number} [minScale] Volitelná specifikace úrovně minimálního přiblížení. Výchozí hodnota je 500.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        publicPrintFeatures(topic: string, kodOrganizace: string, feature: Array<Feature>, outputFormat?: EnumOutputFormat, minScale?: number, options?: any): AxiosPromise<File> {
            return localVarFp.publicPrintFeatures(topic, kodOrganizace, feature, outputFormat, minScale, options).then((request) => request(axios, basePath));
        },
        /**
         * Vytiskne mapu pro features v selectedLayers predaneho topicu ve veřejném režimu
         * @param {string} topic ID tématu pro tisk.
         * @param {string} kodOrganizace Kód organizace pro načtení topicu a vrstev.
         * @param {PrintBodyVO} printBodyVO 
         * @param {boolean} [forceBaseStyle] Příznak pro vynucení základního stylu.
         * @param {Array<number>} [backgroundLayerIds] ID pozadových vrstev.
         * @param {Array<number>} [layerIds] ID vektorových vrstev.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        publicPrintFeaturesForLayers(topic: string, kodOrganizace: string, printBodyVO: PrintBodyVO, forceBaseStyle?: boolean, backgroundLayerIds?: Array<number>, layerIds?: Array<number>, options?: any): AxiosPromise<File> {
            return localVarFp.publicPrintFeaturesForLayers(topic, kodOrganizace, printBodyVO, forceBaseStyle, backgroundLayerIds, layerIds, options).then((request) => request(axios, basePath));
        },
        /**
         * Vytiskne mapu pro features v selectedLayers predaneho topicu ve veřejném režimu
         * @param {string} topic ID tématu pro tisk.
         * @param {string} kodOrganizace Kód organizace pro načtení topicu a vrstev.
         * @param {TopicPrintRequestVO} topicPrintRequestVO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        publicPrintFeaturesForTopic(topic: string, kodOrganizace: string, topicPrintRequestVO: TopicPrintRequestVO, options?: any): AxiosPromise<File> {
            return localVarFp.publicPrintFeaturesForTopic(topic, kodOrganizace, topicPrintRequestVO, options).then((request) => request(axios, basePath));
        },
        /**
         * Vytiskne mapu rozdělenou na více stránek (klad listů) ve veřejném režimu.
         * @param {string} topic ID tématu pro tisk.
         * @param {string} kodOrganizace Kód organizace pro načtení topicu a vrstev.
         * @param {string} format velikost stránky (A4, A3, ...)
         * @param {number} vyska maximální výška čtverce
         * @param {number} sirka maximální šířka jednoho čtverce (v metrech jako JTSK)
         * @param {Polygon} polygon 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        publicPrintKladlistuForTopic(topic: string, kodOrganizace: string, format: string, vyska: number, sirka: number, polygon: Polygon, options?: any): AxiosPromise<File> {
            return localVarFp.publicPrintKladlistuForTopic(topic, kodOrganizace, format, vyska, sirka, polygon, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PublicPrintControllerApi - interface
 * @export
 * @interface PublicPrintControllerApi
 */
export interface PublicPrintControllerApiInterface {
    /**
     * 
     * @param {string} kodOrganizace Kód organizace pro načtení konfigurace tisku.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PublicPrintControllerApiInterface
     */
    publicGetPrintConfig(kodOrganizace: string, options?: any): AxiosPromise<PrintConfigVO>;

    /**
     * 
     * @param {string} topic ID tématu pro tisk.
     * @param {string} kodOrganizace Kód organizace pro načtení topicu a vrstev.
     * @param {Array<Feature>} feature 
     * @param {EnumOutputFormat} [outputFormat] 
     * @param {number} [minScale] Volitelná specifikace úrovně minimálního přiblížení. Výchozí hodnota je 500.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PublicPrintControllerApiInterface
     */
    publicPrintFeatures(topic: string, kodOrganizace: string, feature: Array<Feature>, outputFormat?: EnumOutputFormat, minScale?: number, options?: any): AxiosPromise<File>;

    /**
     * Vytiskne mapu pro features v selectedLayers predaneho topicu ve veřejném režimu
     * @param {string} topic ID tématu pro tisk.
     * @param {string} kodOrganizace Kód organizace pro načtení topicu a vrstev.
     * @param {PrintBodyVO} printBodyVO 
     * @param {boolean} [forceBaseStyle] Příznak pro vynucení základního stylu.
     * @param {Array<number>} [backgroundLayerIds] ID pozadových vrstev.
     * @param {Array<number>} [layerIds] ID vektorových vrstev.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PublicPrintControllerApiInterface
     */
    publicPrintFeaturesForLayers(topic: string, kodOrganizace: string, printBodyVO: PrintBodyVO, forceBaseStyle?: boolean, backgroundLayerIds?: Array<number>, layerIds?: Array<number>, options?: any): AxiosPromise<File>;

    /**
     * Vytiskne mapu pro features v selectedLayers predaneho topicu ve veřejném režimu
     * @param {string} topic ID tématu pro tisk.
     * @param {string} kodOrganizace Kód organizace pro načtení topicu a vrstev.
     * @param {TopicPrintRequestVO} topicPrintRequestVO 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PublicPrintControllerApiInterface
     */
    publicPrintFeaturesForTopic(topic: string, kodOrganizace: string, topicPrintRequestVO: TopicPrintRequestVO, options?: any): AxiosPromise<File>;

    /**
     * Vytiskne mapu rozdělenou na více stránek (klad listů) ve veřejném režimu.
     * @param {string} topic ID tématu pro tisk.
     * @param {string} kodOrganizace Kód organizace pro načtení topicu a vrstev.
     * @param {string} format velikost stránky (A4, A3, ...)
     * @param {number} vyska maximální výška čtverce
     * @param {number} sirka maximální šířka jednoho čtverce (v metrech jako JTSK)
     * @param {Polygon} polygon 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PublicPrintControllerApiInterface
     */
    publicPrintKladlistuForTopic(topic: string, kodOrganizace: string, format: string, vyska: number, sirka: number, polygon: Polygon, options?: any): AxiosPromise<File>;

}

/**
 * PublicPrintControllerApi - object-oriented interface
 * @export
 * @class PublicPrintControllerApi
 * @extends {BaseAPI}
 */
export class PublicPrintControllerApi extends BaseAPI implements PublicPrintControllerApiInterface {
    /**
     * 
     * @param {string} kodOrganizace Kód organizace pro načtení konfigurace tisku.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PublicPrintControllerApi
     */
    public publicGetPrintConfig(kodOrganizace: string, options?: any) {
        return PublicPrintControllerApiFp(this.configuration).publicGetPrintConfig(kodOrganizace, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} topic ID tématu pro tisk.
     * @param {string} kodOrganizace Kód organizace pro načtení topicu a vrstev.
     * @param {Array<Feature>} feature 
     * @param {EnumOutputFormat} [outputFormat] 
     * @param {number} [minScale] Volitelná specifikace úrovně minimálního přiblížení. Výchozí hodnota je 500.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PublicPrintControllerApi
     */
    public publicPrintFeatures(topic: string, kodOrganizace: string, feature: Array<Feature>, outputFormat?: EnumOutputFormat, minScale?: number, options?: any) {
        return PublicPrintControllerApiFp(this.configuration).publicPrintFeatures(topic, kodOrganizace, feature, outputFormat, minScale, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Vytiskne mapu pro features v selectedLayers predaneho topicu ve veřejném režimu
     * @param {string} topic ID tématu pro tisk.
     * @param {string} kodOrganizace Kód organizace pro načtení topicu a vrstev.
     * @param {PrintBodyVO} printBodyVO 
     * @param {boolean} [forceBaseStyle] Příznak pro vynucení základního stylu.
     * @param {Array<number>} [backgroundLayerIds] ID pozadových vrstev.
     * @param {Array<number>} [layerIds] ID vektorových vrstev.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PublicPrintControllerApi
     */
    public publicPrintFeaturesForLayers(topic: string, kodOrganizace: string, printBodyVO: PrintBodyVO, forceBaseStyle?: boolean, backgroundLayerIds?: Array<number>, layerIds?: Array<number>, options?: any) {
        return PublicPrintControllerApiFp(this.configuration).publicPrintFeaturesForLayers(topic, kodOrganizace, printBodyVO, forceBaseStyle, backgroundLayerIds, layerIds, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Vytiskne mapu pro features v selectedLayers predaneho topicu ve veřejném režimu
     * @param {string} topic ID tématu pro tisk.
     * @param {string} kodOrganizace Kód organizace pro načtení topicu a vrstev.
     * @param {TopicPrintRequestVO} topicPrintRequestVO 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PublicPrintControllerApi
     */
    public publicPrintFeaturesForTopic(topic: string, kodOrganizace: string, topicPrintRequestVO: TopicPrintRequestVO, options?: any) {
        return PublicPrintControllerApiFp(this.configuration).publicPrintFeaturesForTopic(topic, kodOrganizace, topicPrintRequestVO, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Vytiskne mapu rozdělenou na více stránek (klad listů) ve veřejném režimu.
     * @param {string} topic ID tématu pro tisk.
     * @param {string} kodOrganizace Kód organizace pro načtení topicu a vrstev.
     * @param {string} format velikost stránky (A4, A3, ...)
     * @param {number} vyska maximální výška čtverce
     * @param {number} sirka maximální šířka jednoho čtverce (v metrech jako JTSK)
     * @param {Polygon} polygon 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PublicPrintControllerApi
     */
    public publicPrintKladlistuForTopic(topic: string, kodOrganizace: string, format: string, vyska: number, sirka: number, polygon: Polygon, options?: any) {
        return PublicPrintControllerApiFp(this.configuration).publicPrintKladlistuForTopic(topic, kodOrganizace, format, vyska, sirka, polygon, options).then((request) => request(this.axios, this.basePath));
    }
}
